<template>
<div id="app">
  <h2>mode - up</h2>
  <FlipCounter
    size="75"
    v-model="value"
    :interval="2000"
  />

  <hr>

  <h2>mode - down</h2>
  <FlipCounter
    size="75"
    v-model="value2"
    :interval="2000"
    mode="down"
  />
</div>
</template>

<script>

export default {
  name: 'app',

  data() {
    return {
      value: 0,
      value2: 9,
    }
  },

  methods: {

  }
}
</script>
